import "./styles/index.scss";
import "filepond/dist/filepond.min.css";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/scrollbar";
import "swiper/scss/pagination";
import { AxiomRouteLogger } from "@common/utils/axiom-route-logger";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import React from "react";
import { Helmet } from "react-helmet";

import { withContexts } from "./contexts";
import { withChatContext } from "./contexts/Chat/ChatContext";
import { useFavicon } from "./contexts/Chat/use-favicon";
import { withMediaLibraryContext } from "./contexts/MediaLibrary/MediaLibraryContext";
import { withQueryParamsContext } from "./contexts/QueryParamsContext";
import { withQuickAssistContext } from "./contexts/QuickAssist/QuickAssistContext";
import { withSocketContext } from "./contexts/SocketContext";
import { withTaskContext } from "./contexts/Tasks/TaskContext";
import { useUser, withUserContext } from "./contexts/UserContext";
import "./modules/projects/view/ProjectContext";
import { Header } from "./modules/header/Header";
import { AppRoutes } from "./modules/routes/AppRoutes";
import { Sidebar } from "./modules/sidebar/Sidebar";

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

export function AppComponent() {
  const { user } = useUser();
  useFavicon();

  return (
    <div className="h-screen">
      <Helmet>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="icon" sizes="48x48" href="/favicon.ico" />
        <link rel="manifest" href="/site.webmanifest" />
      </Helmet>
      <Header />

      <AxiomRouteLogger user={user} />

      <div className="pt-[77px] h-full overflow-y-auto overflow-x-hidden">
        {user ? (
          <div className="flex w-full h-full">
            <div
              id="scroll-container"
              className="w-full h-full overflow-auto transition-width ease-in-out duration-500"
            >
              <AppRoutes />
            </div>

            <Sidebar />
          </div>
        ) : (
          <AppRoutes />
        )}
      </div>
    </div>
  );
}

const App = withContexts(
  [
    withTaskContext,
    withMediaLibraryContext,
    withChatContext,
    withSocketContext,
    withQuickAssistContext,
    withUserContext,
    withQueryParamsContext,
  ],
  AppComponent
);

export { App };
